import React from "react";
import { Box } from "@catchoftheday/cg-components";
import { PersonalDetailsFormContainer } from "../PersonalDetailsFormContainer/PersonalDetailsFormContainer.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PersonalDetailsContainer = function PersonalDetailsContainer(_ref) {
  var host = _ref.host;
  return ___EmotionJSX(Box, {
    pb: 8
  }, ___EmotionJSX(PersonalDetailsFormContainer, {
    host: host
  }));
};